import { Avatar, Box, Typography } from "@mui/material";
import TableComponent from "../GreenCity/TableComponent";
import Separator from "../Separator";
import { colors } from "../../common/colors";
import DropDown from "../DropDown";
import dayjs from "dayjs";
import { useState, useEffect } from "react";
import { T, TF } from "react-translator-component";
import appServices from "../../services/app-services/appServices";

const EventApplicationDetails = ({
  item,
  selectedValues,
  handleChange,
  dropdownDisabled = false,
}: any) => {

  const [groupIcon, setGroupIcon] = useState<any>()

  useEffect(() => {
    appServices.getGroupIcon(item?.member_group?.id).then(blob => {
      setGroupIcon(URL.createObjectURL(blob));
    }).catch(() => {
      console.error("Failed to get group icon image")
    })
  }, [])

  const createDropDown = (
    maxNumber: any,
    selectedValue: any,
    handleChange: any
  ) => {
    const limitedMaxNumber = Math.min(maxNumber, 5);
    const options = Array.from({ length: limitedMaxNumber }, (_, i) => ({
      value: i + 1,
      name: TF("{0}{1}", i + 1, T("unit_person")),
    }));
    options.unshift({ value: 0, name: TF("0{0}", T("unit_person")) });

    return (
      <DropDown
        title={``}
        disabled={maxNumber === 0 || dropdownDisabled}
        value={selectedValue}
        options={options}
        onChange={handleChange}
      />
    );
  };

  const detail = item?.post_events[0];

  const getTotalParticipantsPerEvent = () => {
    const eventTotals: any = [];

    if (detail?.users.length === 0) return [0];

    detail?.users?.forEach((user: any) => {
      const applicationDetails = user.application_details;

      applicationDetails.forEach((applicationDetail: any) => {
        if (!eventTotals[applicationDetail.name]) {
          eventTotals[applicationDetail.name] = 0; // Initialize event total if not present
        }

        const numberOfParticipants =
          user.status === 'applied' || user.status === 'confirmed' ? applicationDetail.number_of_participants : 0
        eventTotals[applicationDetail.name] += numberOfParticipants; // Add participants
      });
    });

    return Object.values(eventTotals);
  };
  const formatEventDate = (start_date: any, end_date: any) => {
    const startDate = dayjs(start_date);
    const endDate = dayjs(end_date);

    if (startDate.isSame(endDate, "day")) {
      // If start and end dates are the same
      return startDate.format("YYYY年M月D日(ddd)");
    } else {
      // If start and end dates are different
      return `${startDate.format("YYYY年M月D日(ddd)")}~${endDate.format(
        "M月D日(ddd)"
      )}`;
    }
  };

  const totalParticipants = (participantSetting: any, index: number) => {
    const totalAllowed: any = getTotalParticipantsPerEvent() || [];
    const allowedParticipants = totalAllowed[index] || 0;

    return parseInt(participantSetting.number_of_participants) - allowedParticipants;
  }


  return (
    <Box>
      <Box sx={{ marginTop: 4 }}>
        <Typography sx={{ marginBottom: 1, fontWeight: "bold" }}>
          {T("event_application_detail_information")}
        </Typography>
        <TableComponent
          data={[
            {
              col1: T("event_application_detail_host"),
              col2: (
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "start",
                    alignItems: "center",
                    gap: 1,
                  }}
                >
                  <Avatar
                    sx={{ width: 25, height: 25, objectFit: "cover" }}
                    alt="Remy Sharp"
                    src={groupIcon}
                  />
                  <Typography>{item?.member_group?.name}</Typography>
                </Box>
              ),
            },
            {
              col1: T("event_name"),
              col2: detail?.title,
            },

            {
              col1: T("event_application_application_term"),
              col2: (
                <Box>
                  <Typography
                    sx={{ color: "#A2A2A2", fontSize: 12, marginLeft: 1 }}
                  >
                    {formatEventDate(
                      detail?.application_start_date,
                      detail?.application_end_date
                    )}
                  </Typography>
                </Box>
              ),
            },
          ]}
        />
      </Box>
      <Box sx={{ marginTop: 4 }}>
        <Typography sx={{ marginBottom: 1, fontWeight: "bold" }}>
          {T("participant_settings")}
        </Typography>

        {detail.participant_settings &&
          detail.participant_settings?.map((participantSetting: any, index: number) => {
            return (
              <Box
                sx={{
                  padding: "10px 10px",
                  backgroundColor: colors.farm_gray15,
                }}
                key={index}
              >
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      gap: "8px",
                    }}
                  >
                    <Typography>
                      {participantSetting.name} :
                      {participantSetting.free ? T("free") : parseInt(participantSetting.fee_amount)}
                    </Typography>
                    <Typography sx={{ color: colors.farm_gray200 }}>
                      {TF(T("event_application_number_of_persons"), parseInt(participantSetting.number_of_participants))}
                    </Typography>
                  </Box>
                  <Box sx={{ marginTop: "-5px" }}>
                    {createDropDown(
                      totalParticipants(participantSetting, index),
                      selectedValues[index],
                      handleChange(index)
                    )}
                  </Box>
                </Box>
                <Separator
                  color={colors.farm_green100}
                  sx={{ height: "2px" }}
                />
              </Box>
            );
          })}
      </Box>
    </Box>
  );
};

export default EventApplicationDetails;
